import { h } from 'preact';
import { useContext } from 'preact/compat';
import { Theme } from '../../lib/render';
import { useDonationStep, DonationStepEnum } from '../../hooks/step';
import { validCheckoutTransition, validConfirmTransition } from '../../hooks/transitionGaurds';

/**
 * Composable link action.
 */
const NavLinkAction = ({
	label,
	donationStep,
	disableCondition = false,
}:{
	label: string,
	donationStep: DonationStepEnum,
	disableCondition?: boolean;
}) => {
	const { state, dispatch } = useDonationStep();
	const isActive = donationStep === state;
	return (
		<li>
			<a
				href={`#${donationStep}`}
				data-active={isActive}
				disabled={disableCondition}
				onClick={(e) => {
					e.preventDefault();
					if (!isActive && !disableCondition) {
						dispatch({
							type: 'MANUAL_STEP',
							payload: {
								step: donationStep,
							},
						});
					}
				}}
			>
				{label}
			</a>
		</li>
	);
};

/**
 * Flow Navigation.
 * Handles its own checks internally.
 *
 * @param {string} props.initLabel The label for the first step.
 * Defaults to theme.donate_type_label or 'Donate'.
 */
const CheckoutNavigation = ({
	initLabel = null,
	paymentLabel = 'Payment',
	confirmLabel = 'Confirm',
}:{
	initLabel?: string;
	paymentLabel?: string;
	confirmLabel?: string;
}) => {
	const theme = useContext(Theme);
	const label = initLabel ?? (theme?.donate_type_label ?? 'Donate');
	return (
		<div className="ea-navigation">
			<nav aria-label="Donation Steps">
				<ul className="ea-flat-list">
					<NavLinkAction
						label={label}
						donationStep={DonationStepEnum.ENTRY}
					/>
					<NavLinkAction
						label={paymentLabel}
						donationStep={DonationStepEnum.CHECKOUT}
						// Disable if no selections.
						disableCondition={!validCheckoutTransition()}
					/>
					<NavLinkAction
						label={confirmLabel}
						donationStep={DonationStepEnum.CONFIRM}
						// Disable if invalid user/vgs.
						disableCondition={!validConfirmTransition()}
					/>
				</ul>
			</nav>
		</div>
	);
};

export default CheckoutNavigation;
